import { createSlice } from '@reduxjs/toolkit';
import { addCollege, fetchColleges } from '../actions/collegesActions';


// Create a slice
const collegesSlice = createSlice({
    name: 'colleges',
    initialState: {
      data: [],
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchColleges.pending, (state) => {
          state.loading = true;
        })
        .addCase(fetchColleges.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
        })
        .addCase(fetchColleges.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        })
        .addCase(addCollege.pending, (state) => {
          state.loading = true;
        })
        .addCase(addCollege.fulfilled, (state, action) => {
          state.loading = false;
          state.data.push(action.payload);
        })
        .addCase(addCollege.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
    },
  });
  
  export default collegesSlice.reducer;
  
  export { fetchColleges };